

import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { stateAbbrev } from '../../utils/utils';
import styles from './LinksPage.css';
import withStyles from '../../decorators/withStyles';


class LinksPage extends Component {

  render() {
    const { placeContainer } = this.props;
    var abbrev;
    try {
       abbrev = stateAbbrev(placeContainer.placeType, placeContainer.placeID);
    } catch (err) {
    }

    return (
      <section className="LinksPage">
        <ul>
          {placeContainer ?
            <li><a target="_blank" href={`http://sealevel.climatecentral.org/responses/plans#${placeContainer.name.replace(" ", "_")}`}>Resiliency resources</a></li>
            : null}
          <li><a target="_blank" href={`http://sealevel.climatecentral.org/flood-preparation`}>Personal flood preparation</a></li>
          <li><a target="_blank" href={`http://sealevel.climatecentral.org/maps/custom-analysis`}>Custom analysis</a></li>
          <li><a target="_blank" href={`http://sealevel.climatecentral.org/about/faqs`}>FAQs</a></li>
          <li><a target="_blank" href={`http://sealevel.climatecentral.org/ssrf/help-page`}>Video tutorial</a></li>
          {abbrev ?
            <li><a target="_blank" href={`http://sealevel.climatecentral.org/matrix/${abbrev}.html`}>Tools comparison</a></li>
            : null}
          <li><a target="_blank" href={`http://sealevel.climatecentral.org`}>Surging Seas home</a></li>
        </ul>
      </section>
    );
  };

}

export default compose(
  withStyles(styles),
  connect((state) => {return {placeContainer: state.placeContainer};}),
)(LinksPage);
